export const GET_SONG = 'GET_SONG'
export const GET_SONG_BY_ID = 'GET_SONG_BYid'
export const CREATE_SONG = 'CREATE_SONG'
export const UPDATE_SONG_BY_ID = 'UPDATE_SONG_BYid'
export const DELETE_SONG_BY_ID = 'DELETE_SONG_BYid'
